import { render, staticRenderFns } from "./SubscriberAgreementView.vue?vue&type=template&id=78081b59&"
import script from "./SubscriberAgreementView.vue?vue&type=script&lang=js&"
export * from "./SubscriberAgreementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports